import { Component, OnDestroy, OnInit } from '@angular/core';
import {EducationObservationService} from "../education-observation.service";
import {ActivatedRoute} from "@angular/router";
import {EducationObservation} from "../education-observation.model";
import {MatSelectChange} from "@angular/material/select";
import {combineLatest, Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {CentreOption} from "../../../../../interfaces/Centres";
import {FormControl} from "@angular/forms";
import {EmployeeService} from "../../../../../services/employee.service";
import {CentreService} from "../../../../../services/centre.service";
import {EducationService} from "../../../education.service";
import {buildDirectoryLevels, canView, getCurrentUserLevel, observedLevelOf} from "../education-observation-access";
@Component({
  selector: 'app-view-education-observation',
  templateUrl: './view-education-observation.component.html',
  styleUrls: ['./view-education-observation.component.scss']
})
export class ViewEducationObservationComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  observation!: EducationObservation | null;
  isLoading: boolean = true;
  /** True when the record exists but sits at or above the viewer's level. */
  accessDenied = false;

  // Track expanded state for each field
  expandedFields: { [key: string]: boolean } = {
    topic: false,
    teachingAid: false,
    observationComment: false,
    suggestions: false
  };

  constructor(
    private route: ActivatedRoute,
    private observationService: EducationObservationService,
    private employeeService: EmployeeService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (!id) {
      this.isLoading = false;
      return;
    }

    // Guard direct URL access: the list already filters, but this route can be opened by id.
    combineLatest([
      this.observationService.getDataById(id),
      this.employeeService.getAllUsers()
    ]).pipe(takeUntil(this._destroyed$)).subscribe(([data, users]) => {
      const record = data ?? null;
      const allowed = !!record &&
        canView(getCurrentUserLevel(), observedLevelOf(record, buildDirectoryLevels(users)));

      this.accessDenied = !!record && !allowed;
      this.observation = allowed ? record : null;
      this.isLoading = false;
    });
  }
  formatField(value: any): string {
    if (!value) return '';
    // If array → join
    if (Array.isArray(value)) {
      return value.join(', ');
    }
    // If string
    return value;
  }


  // Method to truncate text to specified word count
  getTruncatedText(text: string | undefined, wordLimit: number = 50): string {
    if (!text) return '';
    const words = text.split(' ');
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(' ') + '...';
  }

  // Check if text exceeds word limit
  shouldShowMoreButton(text: string | undefined, wordLimit: number = 50): boolean {
    if (!text) return false;
    return text.split(' ').length > wordLimit;
  }

  // Toggle expanded state
  toggleExpanded(field: string): void {
    this.expandedFields[field] = !this.expandedFields[field];
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
